<template>
  <div class="surveillance-dataset-state">
    <div v-if="step == null">
      <alert type="warning">
        <p class="text-justify">
          <strong>
            Une fois toutes vos fiches saisies (ou si vous n'avez pas de
            fiche), merci de bien vouloir envoyer vos données au
            programme national en utilisant le bouton ci-dessous.
          </strong>
        </p>
        <p class="text-justify">
          Il vous sera demandé de :
          <ul>
            <li>
              Spécifier la période de surveillance
            </li>
            <li>
              Valider les fiches de cette période
            </li>
            <li>
              Saisir les dénominateurs pour cette période
            </li>
          </ul>
        </p>
      </alert>
    </div>
    <div v-else-if="step === 0">
      <alert type="warning">
        <p class="text-justify">
          <strong>
            Attention ! Aucune fiche n'a été sélectionnée pour envoi au
            programme national SPIADI {{year}}.
          </strong>
        </p>
        <p class="text-justify">
          Une fois toutes vos fiches saisies, utilisez le bouton
          ci-dessous afin de les envoyer au programme national et de
          saisir les dénominateurs pour la période surveillée.
        </p>
      </alert>
    </div>
    <div v-else-if="step === 1">
      <alert type="warning">
        <p class="text-justify">
          <strong>
            Attention ! Les dénominateurs n'ont pas été renseignés
            pour la période surveillée.
          </strong>
        </p>
        <p class="text-justify">
          Vous pouvez d'ores et déjà les saisir en utilisant le
          bouton ci-dessous.
        </p>
      </alert>
    </div>
    <div v-else-if="step === 2">
      <alert type="success">
        <p class="text-justify">
          <strong>
            Vos données ont bien été envoyées au programme national.
          </strong>
        </p>
      </alert>
      <alert type="warning">
        <p class="text-justify">
          <strong>
            Attention ! Si vous effectuez des ajouts, suppressions ou
            modifications de fiches correspondant à votre période
            de surveillance, n'oubliez pas de mettre vos données du
            programme national à jour en cliquant sur le bouton
            ci-dessous.
          </strong>
        </p>
      </alert>
    </div>
  </div>
</template>
<script>
export default {
  name: 'surveillance-dataset-state',

  props: {
    year: {
      type: String,
      required: true
    },

    step: {
      type: Number
    }
  }
}
</script>
<style scoped lang="less">
.panel {
  .alert:last-child {
    margin-bottom: 0rem !important;
  }
}
</style>
